import type { CalendarView } from 'components/CalendarV2/types';
import RestAPI from 'components/Common/restApi';

export type FetchedCalendarPreferences = {
  calendar_show_new_schedule_dialog: boolean;
  calendar_show_v1_multi_tech_layout: boolean;
  calendar_time_zone: string;
  default_arrival_window_minutes: number;
  default_calendar_view: CalendarView;
  default_scheduler_view: string;
  id: string;
  object: string;
  show_amount: boolean;
  show_arrival_window: boolean;
  show_city_state: boolean;
  show_customer_name: boolean;
  show_customer_phone_number: boolean;
  show_due: boolean;
  show_invoice_number: boolean;
  show_job_name: boolean;
  show_schedule_time: boolean;
  show_street: boolean;
  show_team: boolean;
  show_work_hours: boolean;
  show_zip: boolean;
};

export default class Api {
  static show(employeeId: string) {
    return RestAPI.get<FetchedCalendarPreferences>(`/alpha/organization/employees/${employeeId}/preferences`);
  }

  static update<PayloadType = Partial<FetchedCalendarPreferences>>(employeeId: string, preferences: PayloadType) {
    return RestAPI.updateWithFormData<FetchedCalendarPreferences, PayloadType>(
      `/alpha/organization/employees/${employeeId}/preferences`,
      preferences
    );
  }
}
